import API from './api.svelte.js';
import { notificate } from './notification.js';


export function save(data = {}, files = [], config = {}) {

    let url = 'document/';
    let file;

    if(data.asset_id){
        url = url + '?asset_id=' + data.asset_id;
    }
    if(data.force_private_ip){
        url = url + (data.asset_id ? "&" : "?") + 'force_private_ip=' + data.force_private_ip;
    }
    if(files && !files.length) {
        file = [];
        file.push(files)
    }
    return API.saveDocument(url, data, file, config)
        .then(async (response) => {
            if (!response.ok) {

                let errors = await response.json();
                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            notificate('save_ok', "toast", {data: 'Archivo'});
            //returns saved element to update dataTables
            return apiData;
        })
    ;
}

export default{
    save
}
